import { RoutingPaths } from 'app/routes/routes'

import { UserAuthorityType } from 'entities/user/module'

import { AllIcons } from 'shared/ui/app-icon/types'

export type PagesModule =
  | 'avia'
  | 'excursion'
  | 'buses'
  | 'tours'
  | 'umrah'
  | 'kyrgyzstan'

export interface Props {
  isTicket?: boolean
  isDevUser?: boolean
  active: PagesModule
  hideModules?: PagesModule[]
  authorityType?: string
  onClick: (module: PagesModule) => void
}

interface NewTabs {
  name?: string
  activeIcon: AllIcons
  disabledIcon: AllIcons
  backgroundColor?: string
}

export interface TabPage {
  icon: AllIcons
  module: PagesModule
  color: string
  avia: string
  excursion: string
  key: string
  buses: string
  tours: string
  umrah: string
  kyrgyzstan: string
  isNew?: boolean
  isHideMainPage?: boolean
  isHideMainMyTicker?: boolean
  isForDevUsers?: boolean
  hideForUserAuthorityType?: UserAuthorityType[]
  newTabs?: NewTabs
}

export interface IPagesModuleRouter {
  avia: TabPage
  excursion: TabPage
  buses?: TabPage
  tours?: TabPage
  umrah?: TabPage
  kyrgyzstan?: TabPage
}

// export const OrdersPagesModuleRouter = {
//   avia: RoutingPaths.avia.myTickets.path(),
//   excursion: RoutingPaths.excursion.orders.path(),
//   buses: RoutingPaths.beket.orders.path(),
//   tours: RoutingPaths.tours.myOrders.path(),
//   umrah: RoutingPaths.umrah.myOrders.path(),
//   kyrgyzstan: RoutingPaths.kyrgyzstan.myOrders.path(),
// }

export const PagesModuleRouter: IPagesModuleRouter = {
  avia: {
    key: 'avia',
    module: 'avia',
    color: '#5baaff',
    avia: RoutingPaths.path(),
    icon: AllIcons.AIRPLANE,
    excursion: RoutingPaths.excursion.path(),
    buses: RoutingPaths.beket.path(),
    tours: RoutingPaths.tours.path(),
    umrah: RoutingPaths.umrah.path(),
    kyrgyzstan: RoutingPaths.kyrgyzstan.path(),
    newTabs: {
      activeIcon: AllIcons.PLANE_ACTIVE,
      disabledIcon: AllIcons.PLANE_DISABLED,
      backgroundColor: 'linear-gradient(180deg, #268FFF 0%, #54A1F3 74%)',
      name: 'flights_main',
    },
  },
  tours: {
    key: 'tours',
    module: 'tours',
    color: '#FF6277',
    avia: RoutingPaths.path(),
    icon: AllIcons.EARTH,
    excursion: RoutingPaths.excursion.path(),
    buses: RoutingPaths.beket.path(),
    tours: RoutingPaths.tours.path(),
    umrah: RoutingPaths.umrah.path(),
    kyrgyzstan: RoutingPaths.kyrgyzstan.path(),
    isHideMainMyTicker: false,
    newTabs: {
      backgroundColor: 'linear-gradient(180deg, #FA4496 0%, #E96552 74%)',
      activeIcon: AllIcons.TOUR_ACTIVE,
      disabledIcon: AllIcons.TOUR_DISABLED,
      name: 'tours_main',
    },
  },
  kyrgyzstan: {
    key: 'kyrgyzstan',
    module: 'kyrgyzstan',
    color: '#DC4032',
    avia: RoutingPaths.path(),
    icon: AllIcons.KYRGYZSTAN,
    excursion: RoutingPaths.excursion.path(),
    buses: RoutingPaths.beket.path(),
    tours: RoutingPaths.tours.path(),
    umrah: RoutingPaths.umrah.path(),
    kyrgyzstan: RoutingPaths.kyrgyzstan.path(),
    newTabs: {
      backgroundColor: 'linear-gradient(180deg, #ED5555 0%, #E14848 74%)',
      activeIcon: AllIcons.KYRGYZSTAN_ACTIVE,
      disabledIcon: AllIcons.KYRGYZSTAN_DISABLED,
      name: 'kyrgyzstan_main',
    },
  },
  // buses: {
  //   key: 'buses',
  //   module: 'buses',
  //   color: '#8279EB',
  //   avia: RoutingPaths.path(),
  //   icon: AllIcons.BUS,
  //   excursion: RoutingPaths.excursion.path(),
  //   buses: RoutingPaths.beket.path(),
  //   tours: RoutingPaths.tours.path(),
  //   umrah: RoutingPaths.umrah.path(),
  //   kyrgyzstan: RoutingPaths.kyrgyzstan.path(),
  //   newTabs: {
  //     backgroundColor: 'linear-gradient(180deg, #3863D6 0%, #8A94E2 100%)',
  //     activeIcon: AllIcons.BUS_ACTIVE,
  //     disabledIcon: AllIcons.BUS_DISABLED,
  //     name: 'buses_main',
  //   },
  // },
  // umrah: {
  //   key: 'umrah',
  //   module: 'umrah',
  //   color: '#2AB626',
  //   avia: RoutingPaths.path(),
  //   icon: AllIcons.CRESCENT_MOON,
  //   excursion: RoutingPaths.excursion.path(),
  //   buses: RoutingPaths.beket.path(),
  //   tours: RoutingPaths.tours.path(),
  //   umrah: RoutingPaths.umrah.path(),
  //   kyrgyzstan: RoutingPaths.kyrgyzstan.path(),
  //   isNew: true,
  //   // hideForUserAuthorityType: ['BANK_CLIENT'],
  //   newTabs: {
  //     backgroundColor: 'linear-gradient(180deg, #26B51F 0%, #57B454 74%)',
  //     activeIcon: AllIcons.UMARA_ACTIVE,
  //     disabledIcon: AllIcons.UMARA_DISABLED,
  //     name: 'umrah_main',
  //   },
  // },
  excursion: {
    key: 'excursion',
    module: 'excursion',
    color: '#FF8F26',
    avia: RoutingPaths.path(),
    icon: AllIcons.MOUNTAIN,
    excursion: RoutingPaths.excursion.path(),
    buses: RoutingPaths.beket.path(),
    tours: RoutingPaths.tours.path(),
    umrah: RoutingPaths.umrah.path(),
    kyrgyzstan: RoutingPaths.kyrgyzstan.path(),
    newTabs: {
      backgroundColor: 'linear-gradient(180deg, #776BF0 0%, #A279F3 74%)',
      activeIcon: AllIcons.EXCURSIONS_ACTIVE,
      disabledIcon: AllIcons.EXCURSIONS_DISABLED,
      name: 'excursions_main',
    },
  },
}

export const TypesPagesModuleRouterList = Object.keys(PagesModuleRouter)?.map(
  (module) => PagesModuleRouter[module as keyof typeof PagesModuleRouter],
)

export type PagesModuleRouterList = keyof typeof PagesModuleRouter
